import React, { useEffect } from 'react';
import {
    TableRow
} from "@material-ui/core";
import { checkIfNameExists } from '../../../../validations/validations';
import ProjectsTableRowCells from './ProjectsTableRowCells';

//  This component renders a row inside home's table with projects and the row contains info for the project
const ProjectsTableRow = (props) => {

    const {
        row,
        index,
        updateData,
        setUpdateData,
        response,
        setPressVisibilityButton,
        hiddenProjects,
        setHiddenProjects,
        activeProjects,
        setActiveProjects,
        setDisplayKickedOutMessage
    } = props;

    const [status, setStatus] = React.useState('active');
    const [projectRole, setProjectRole] = React.useState('owner');    
    const [showStatus, setShowStatus] = React.useState(true)
    const [init, setInit] = React.useState(false); //   This variable is used to initialize component 

    /**
     * This useEffect is runned when component is rendered for first time.
     * It takes the response from server to check if project is visible or not 
     * and then it sets the corresponding state.
     */
    useEffect( () => {

        if(init === false && response !== undefined){

            setStatus(row.status.toLowerCase());
            if(checkIfNameExists(row._id,response.data.hiddenProjects) === true){
                setShowStatus(false);
            }
            setInit(true);
        }

    },[init,response])
    

    return(
            <TableRow
                hover
                tabIndex={-1}
                id={row.name}
            >
                <ProjectsTableRowCells
                    row={row}
                    index={index}
                    projectRole={projectRole}
                    setProjectRole={setProjectRole}
                    showStatus={showStatus}
                    setShowStatus={setShowStatus}
                    updateData={updateData}
                    setUpdateData={setUpdateData}
                    status={status}
                    setStatus={setStatus}
                    setPressVisibilityButton={setPressVisibilityButton}
                    response={response}
                    hiddenProjects={hiddenProjects}
                    setHiddenProjects={setHiddenProjects}
                    activeProjects={activeProjects}
                    setActiveProjects={setActiveProjects}
                    setDisplayKickedOutMessage={setDisplayKickedOutMessage}
                />
            </TableRow>
        )
}

export default ProjectsTableRow; 